import { type LucideIcon } from "lucide-react";
import { Box, Typography } from "@mui/material";

interface ITimePeriodLabelProps {
    label: string;
    icon: LucideIcon;
    backgroundColor: string;
}

export default function TimePeriodLabel({ label, icon: Icon, backgroundColor }: Readonly<ITimePeriodLabelProps>) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                background: backgroundColor,
                borderRadius: 1,
                px: 1,
                py: 0.5,
                flex: "0 0 107px",
            }}
            data-test-id="time_period_label_container"
        >
            <Icon size={14} strokeWidth={2} data-test-id="time_period_label_icon" aria-hidden />
            <Typography variant="paragraphMediumSemiBold" data-test-id="time_period_label_text">
                {label}
            </Typography>
        </Box>
    );
}
